import React, { useEffect, useState } from "react";
import { CFormText } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import { editPreset, reset } from "../redux/locationsSelectorSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import { useError } from "../hooks/useError";

export const Rename = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");

  const currentPreset = useSelector((state) => state.locations.currentPreset);

  //remove if it is possible
  useEffect(() => {
    setName(currentPreset.name);
  }, [currentPreset.name]);

  const close = (e) => {
    e && e.preventDefault();
    dispatch(reset());
    onClose();
  };

  const { errors } = useError(close);

  const save = () => {
    dispatch(editPreset({ ...currentPreset, name: name.trim() }));
  };

  const onChange = (e) => {
    if (e.target.value.length <= 32) {
      setName(e.target.value);
    }
  };

  return (
    <MainModal
      parentSelector=".location-selector"
      isOpen={isOpen}
      onClose={close}
      headerText="Rename"
      headerCloseHandler={close}
      height="auto"
      width={480}
      primaryButtonText="Save Changes"
      primaryBtnHandler={save}
      primaryButtonClass="primary"
      primaryButtonDisabled={!name}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={close}
      secondaryBtnClass="secondary"
      isAdminPanel={false}
    >
      <div className="location-selector__modal">
        <p className="title">Preset name</p>
        <input type="text" value={name} onChange={onChange} className="location-selector__input" />

        {errors && <CFormText className="help-block">* {errors}</CFormText>}
      </div>
    </MainModal>
  );
};
